import { render, staticRenderFns } from "./TravellingInterest.vue?vue&type=template&id=6db94dfb&scoped=true&"
import script from "./TravellingInterest.vue?vue&type=script&lang=js&"
export * from "./TravellingInterest.vue?vue&type=script&lang=js&"
import style0 from "./TravellingInterest.vue?vue&type=style&index=0&id=6db94dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db94dfb",
  null
  
)

export default component.exports